import request from "@/utils/request";
// import { getToken } from "@/utils/auth"; // get token
import configR from '@/configs.js';
const API = configR.envConfigs.PORTAL_API;
const personAPI = configR.envConfigs.PERSON_CENTER_API;

// 获取 access token
export function getAccessToken(code) {
  return request({
    url: `${API}oauth/token?grant_type=authorization_code&client_id=client-api-resource&client_secret=secret-api-resource&code=${code}&redirect_uri=${configR.envConfigs.VUE_APP_URL}`,
    method: "post"
  });
}

// 获取 jwt token
export function getJwtToken() {
  return request({
    url: `${API}api/common/IDToken/getIDToken`,
    method: "get"
  });
}

// 获取用户信息（门户提供）
// export function getUserInfo() {
//   return request({
//     url: `${API}api/rest/portalUser/selectUserInfoByCurrentUser`,
//     method: "get"
//   });
// }

// 获取用户信息
export function getUserInfo() {
  return request({
    url: `${personAPI}api/v1/personal/user/info`,
    method: "get",
    headerType: "cas"
  });
}

//获取上次登录时间
export function getLastLogin() {
  return request({
    url: `${config.PERSON_CENTER_API}api/v1/personal/user/log/authenticationLog`,
    method: "get",
    headerType: "cas"
  });
}

// 获取用户 IP
export function getUserIP() {
  return request({
    url: "https://bird.ioliu.cn/ip",
    method: "get"
  });
}

// 根据 IP 获取城市
export function getUserCity(params) {
  return request({
    url: `https://bird.ioliu.cn/v1?url=http://ip.taobao.com/service/getIpInfo.php`,
    method: "get",
    params: params
  });
}

// 根据城市获取天气
export function getUserWeather(params) {
  return request({
    url: "https://bird.ioliu.cn/weather",
    method: "get",
    params: params
  });
}

//获取天气

export function getWeather() {
  return request({
    url: `${API}v1/weather/getWeather`,
    method: "get",
    headerType: "portal"
  });
}
